import { Styles } from 'react-joyride';

export const joyRideCommonStyles: Styles = {
  buttonNext: {
    backgroundColor: '#050D43',
    color: '#fff',
    padding: '11px 17px',
    fontSize: 16,
    borderRadius: 20,
    minWidth: 120,
  },
  buttonBack: {
    border: '1px solid #050D43',
    marginRight: 10,

    // backgroundColor: 'transparent',

    color: '#050D43',
    padding: '11px 17px',

    borderRadius: 20,
  },
  tooltipContent: {
    padding: '15px 5px',
  },
  tooltipFooter: {
    marginTop: 5,
  },
  tooltipFooterSpacer: {
    margin: 0,
  },
  buttonClose: {
    // display: "none",
  },
  buttonSkip: {},
  tooltip: {
    borderRadius: 30,
    minWidth: 250,
  },
};
